<template>
  <div style="height: 100%;width: 100%">
    <el-header>
      <el-form :model="formData" label-width="10px">
        <el-row>
          <el-form-item>
            <el-select v-model="formData.wuJianId" style="width:200px ;" clearable placeholder="物件名称">
              <el-option
                  v-for="item in wuJianNames"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker v-model="formData.day" format="YYYY 年 M 月" value-format="YYYY-M-1" type="month"
                            placeholder="选择月份" :clearable="false"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="width: 80px" :loading="searchLoading" @click="getPaintingActualProduction">
              搜索
            </el-button>
            <!-- <el-button type="primary" plain style="width: 80px" :loading="exportLoading" @click="exportProduction">导出</el-button>-->
          </el-form-item>
          <el-button type="warning" style="margin-left: auto" :loading="dataTZRecoveryLoading" @click="tzPlanDataRecovery">计划数据修复</el-button>

        </el-row>
      </el-form>
    </el-header>

    <el-table :data="tableData" border style="width: 100%;margin-top: 10px" :header-cell-style="headerCellStyle">
      <el-table-column prop="wujian_name" label="物件" :min-width="200" fixed/>
      <el-table-column v-for="item in dayList" :key="item" :label="item.day" width="80">
        <el-table-column :label="$t('makeSchedule.processProduceAchievement.plan')" width="70">
          <template v-slot="scope">
            <div v-for="day in scope.row.paintingActualList" :key="day">
              <div :style="planCellStyle(day.area_plan)" style="height: 100%;width: 100%"  v-if="day.date == item.date">{{ day.area_plan===undefined?'&nbsp;':day.area_plan.toLocaleString() }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column :prop="item" :label="$t('makeSchedule.processProduceAchievement.achievements')" width="70">
          <template v-slot="scope">
            <div v-for="day in scope.row.paintingActualList" :key="day">
              <div :style="actualCellStyle(day.area_actual)" v-if="day.date == item.date">{{ day.area_actual===undefined?'&nbsp;':day.area_actual.toLocaleString() }}</div>
            </div>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "AssemblyProduceAchievement",
  components: {},
  data() {
    return {
      wuJianNames: [],
      formData: {
        day: this.getDateFormat(),
        //wuJianId:''
      },
      dataTZRecoveryLoading:false,
      searchLoading: false,
      resetLoading: false,
      exportLoading: false,
      dayList: [],
      tableData: [],
      total: 0,
      pageNo: 1,

    }
  }, methods: {
    getDateFormat() {
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },
    //涂装数据修复
    async tzPlanDataRecovery() {
      this.dataTZRecoveryLoading = true;
      await this.$axios.post('mfg/paintingActual/tzPlanDataRecovery',this.formData).then(response => {
        let res = response.data
        if (res.code !== 0) {
          this.dataTZRecoveryLoading = false;
          return this.$message.error(res.message);
        }
        this.dataTZRecoveryLoading = false;
        return this.$message.success('数据修复成功')
      })
    },
    async getWuJianInFo() {
      let {data: res} = await this.$axios.post('mfg/wujianPlan/getWujianName');
      if (res.code !== 0) {
        this.$message.error('获取【物件信息】失败')
        return;
      }
      this.wuJianNames = res.data;
    },
    getPaintingActualProduction() {
      this.searchLoading = true;
      this.$axios.post('mfg/paintingActual/getPaintingActualProduction', this.formData).then(response => {
        let res = response.data
        if (res.code === 0) {
          this.tableData = res.data.paintingActualDataList
          this.dayList = res.data.dayList
          this.searchLoading = false;
        }
      }, error => {
        this.$message.error(`获取数据失败` + error.message);
      })
    },
    exportProduction() {
      this.exportLoading = true;
      let exportDate = {tableDate: this.tableData, countDayList: this.countDayList}
      this.$axios.post('mfg/paintingActual/exportProduction', exportDate).then(response => {
        this.exportLoading = false;
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error("导出失败" + res.message);
        }

        console.log("res:==", res)
        const url = res.data.data.url;
        const originalName = res.data.data.originalName;
        if (url) {
          const link = document.createElement('a');
          link.href = url;
          link.download = originalName || '' // 下载文件的名字
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
        }
        return this.$message.success("导出成功");
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    planCellStyle(data) {
      let cellStyle = 'background-color:#FFFF0080;text-align: right;'

      if (data < 0){
        cellStyle = 'background-color:lightcoral;color:white;text-align: right;'
      }
      if (data === undefined){
        cellStyle = 'background-color:white;text-align: right;'
      }
      return cellStyle
    },
    actualCellStyle(data) {
      let cellStyle = 'background-color:#4b8de4;color:white;text-align: right;'

      if (data < 0){
        cellStyle = 'background-color:lightcoral;color:white;text-align: right;'
      }
      if (data === undefined){
        cellStyle = 'background-color:white;text-align: right;'
      }
      return cellStyle
    },

    headerCellStyle({column}) {
      let headerCellStyle;

      if (column.label == "计划"){
        headerCellStyle = {color: 'orange'};
      }
      if (column.label == "实绩") {
        headerCellStyle = {color: 'blue'}
      }
      return headerCellStyle;
    },

  }, created() {
    this.getWuJianInFo()
    this.getPaintingActualProduction()
  }
}
</script>

<style scoped>
.padding {
  padding: 5px;
}

.pageStyle {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 20px 0
}

.el-table :deep(.cell) {
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
  padding: 0 12px;
  text-align: center;
}
.el-table :deep(.cell){
  padding: 0px;
}
.el-table :deep(.el-table__cell) {
  padding: 1px;
}
</style>